module.exports = __webpack_public_path__ + "media/features/audio-hero/images/phones-3c6124b42b66639d3579c0da22cb1b5e.png";